import apiClient from '@/services/axios'

export async function post() {
  var response = await apiClient.post('/campaigns/import')
  if (response) {
    return response.data
  }

  throw new Error('Unable to import Campaigns.')
}
